const TopUserIcon = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.2"
        x="0.788818"
        y="0.572876"
        width="36.8348"
        height="37.0051"
        rx="18.4174"
        fill="#05C168"
      />
      <path
        d="M22.4803 12.4966C21.8449 12.4966 21.2182 12.6452 20.6499 12.9307C20.0816 13.2161 19.5873 13.6306 19.2061 14.1413C18.6907 13.4509 17.9721 12.9409 17.1522 12.6836C16.3323 12.4263 15.4525 12.4347 14.6376 12.7076C13.8227 12.9805 13.1139 13.504 12.6117 14.2041C12.1094 14.9042 11.8391 15.7453 11.8391 16.6083C11.8391 21.5354 18.6535 25.4209 18.94 25.5854C19.0212 25.6312 19.1129 25.6549 19.2061 25.6539C19.2993 25.6555 19.3912 25.6319 19.4721 25.5854C20.727 24.8484 21.904 23.9851 22.985 23.0088C25.3657 20.857 26.573 18.7052 26.573 16.6083C26.573 15.5178 26.1418 14.472 25.3743 13.7009C24.6067 12.9298 23.5657 12.4966 22.4803 12.4966Z"
        fill="#05C168"
      />
    </svg>
  );
};

export default TopUserIcon;
